import { DeepPartial } from '@fullstory/typeutils';
import { AppState } from '@fullstory/redux';
import {
  mockConversionMapDetail,
  mockHeatmapDetail,
  mockHeatmapDetailTablet,
  mockHeatmapDetailWithPredeterminedTimestamp,
  mockHeatmapDetailWithUpdatedPageDefinition,
  mockHeatmapWithOldSession,
} from './util';
import { int64 } from '@fullstory/proto/google/protobuf';

export const mockInitialSavedHeatmapsState: DeepPartial<AppState> = {
  heatmaps: {
    heatmaps: {
      1: mockHeatmapWithOldSession,
      17: mockHeatmapDetail,
      18: mockHeatmapDetailWithUpdatedPageDefinition,
      19: mockHeatmapDetailTablet,
      20: mockHeatmapDetailWithPredeterminedTimestamp,
      21: mockConversionMapDetail,
    },
    allHeatmaps: {
      lastRequested: 0,
      lastResponded: 0,
      loading: false,
      error: false,
      data: {
        heatmaps: [
          mockHeatmapWithOldSession,
          mockHeatmapDetail,
          mockHeatmapDetailWithUpdatedPageDefinition,
          mockHeatmapDetailTablet,
          mockHeatmapDetailWithPredeterminedTimestamp,
        ],
      },
    },
    unnamedHeatmap: {
      lastRequested: 1,
      lastResponded: 1,
      loading: false,
      error: false,
      data: {
        1312750952: {
          heatmap: {
            ...mockHeatmapDetail.heatmap?.heatmap,
            heatmapEvent: {
              primary: {
                visitedPage: {
                  equals: {
                    value: [int64.fromNumber(3)],
                  },
                },
              },
              deps: [],
            },
          },
        },
      },
      safeMessage: null,
    },
  },
};
